import { useQuery } from "@tanstack/react-query";
import { graphierQLNextClient } from "utils";
import {
	SpatialQueryReportsQuery,
	SpatialQueryReportsQueryVariables,
} from "~map-view/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query SpatialQueryReports(
		$mapId: ID!
		$queryId: ID!
		$input: SpatialQueryInput!
	) {
		spatialQueryReports(mapId: $mapId, queryId: $queryId, input: $input) {
			content
			processTime
		}
	}
`;

export const useSpatialQueryReports = (
	variables: SpatialQueryReportsQueryVariables,
) => {
	return useQuery({
		enabled: false,
		queryKey: ["spatialQueryReports", variables],
		queryFn: () =>
			graphierQLNextClient<
				SpatialQueryReportsQuery,
				SpatialQueryReportsQueryVariables
			>({
				query,
				variables,
				useKey: true,
			}).then((res) => res.spatialQueryReports),
	});
};
